module.exports = __webpack_public_path__ + "static/media/cert_116.15e2c0d9.jpg";